import React, { Component } from 'react'
import Tick from '../asset/images/tick.svg'

export default class LanguageItem extends Component {

    onclick(){
        //console.log(this.props.langItem);
        this.props.onLangItemClick(this.props.langItem);
    }


    render() {
        return (
            <div className={this.props.langItem.direction==='rtl'?"langItem IRANSansMobileBoldFont":"langItem SFUIDisplayBoldFont"} style={{backgroundColor:this.props.selected?'var(--brown1)':'var(--gray4)'}}>
                <div className="langItemTitle" style={{color:this.props.selected?'white':'var(--gray3)'}}>{this.props.title}</div>
                <div style={{width:'100%',height:'100%',position:'absolute',left:'0',top:'0'}} onClick={this.onclick.bind(this)} />
                {this.props.selected && <img style={{width:'15px',height:'15px',objectFit: 'contain'}} alt="" src={Tick} />}
            </div>
        )
    }
}
